<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import ProviderComponent from './component.provider.svelte'
    import ProvidersComponent from './component.providers.svelte'
    import ProviderCreateComponent from './component.create.svelte'
    import ProviderUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'SettingsView.Providers.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Proveedores" subtitle="Configuración de proveedores de envío" />
    <ProvidersComponent />
</View>

<Modal id="provider_modal" title="Información Proveedor" >
    <ProviderComponent />
</Modal>

<Modal id="provider_create_modal" title="Crear Proveedor" >
    <ProviderCreateComponent />
</Modal>

<Modal id="provider_update_modal" title="Actualizar Proveedor" >
    <ProviderUpdateComponent />
</Modal>
